import { RegisterErrorAsync } from '../helpers/errors-helper';
import { ApiAction, HttpMethods } from '../models/api-model';
import { apiAction } from './base-api';

export const logError = (error, clientId?, apiUrl?): ApiAction => {
	let copy = error;
	if (!error.nonNetwork) {
		copy = {
			clientId,
			url: window.location.href,
			action: error.code === 'ECONNABORTED' ? 'Timeout' : 'Network',
			time: new Date(),
			errorDetail: error.message,
			errorMessage: `Error Request Data at ${apiUrl}`,
		};
	}

	RegisterErrorAsync(error, apiUrl, null, null);
	
	console.log(`[${copy?.action}][${copy.time?.toDateString()}] ${copy.clientId} ${copy.errorMessage} ${copy.errorDetail}`);

	return apiAction({
		method: HttpMethods.POST,
		url: '/api/v1/errorlogging/error',
		payloadData: copy,
	},
	);

};

